import React, { useState, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEnvelope,
  faGlobe,
  faShoppingBag,
} from "@fortawesome/free-solid-svg-icons";
import "../../css/header.css";
import "../../css/bootstrap.css";
import "../../css/element.css";
import "../../css/flaticon.css";
import "../../css/font-awesome.css";
import "../../css/global.css";
import "../../css/responsive.css";
import "../../css/style.css";
import { Link } from "react-router-dom";

function Header() {

  const [servicesDropdownVisible, setServicesDropdownVisible] = useState(false);
  const [blogDropdownVisible, setBlogDropdownVisible] = useState(false);
  const headerRef = useRef(null);


  const toggleDropdown = (menuType) => {
    if (menuType === "services") {
      setServicesDropdownVisible(!servicesDropdownVisible);
    } else if (menuType === "blog") {
      setBlogDropdownVisible(!blogDropdownVisible);
    }
  };

  

  const [isToggle, setIsToggle] = useState(false);

  const handleToggle = () => {
    setIsToggle(!isToggle);
  };
  useEffect(() => {
    // Dynamically adjust the header height based on content
    const headerElement = headerRef.current;
    if (headerElement) {
      headerElement.style.height =
        servicesDropdownVisible || blogDropdownVisible
          ? `${headerElement.scrollHeight}px`
          : "auto";
    }
  }, [servicesDropdownVisible, blogDropdownVisible]);

  return (
    <div className="page-wrapper">
      <div className="preloader"></div>
      <header className="main-header">
        <div className="header-top">
          <div className="container-fluid clearfix">
            <div className="top-left float-left">
              <ul
                style={{ marginTop: "6px", marginBottom: "0px" }}
                className="links-nav clearfix"
              >
                
              </ul>
            </div>
            <div className="top-right float-right">
              <div
                style={{ marginTop: "6px", marginBottom: "0px" }}
                className="social-links clearfix"
              >
                <a href="#">
                  <span className="fa fa-facebook-f"></span>
                </a>
                <a href="#">
                  <span className="fa fa-twitter"></span>
                </a>
                <a href="#">
                  <span className="fa fa-vimeo"></span>
                </a>
                <a href="#">
                  <span className="fa fa-pinterest-p"></span>
                </a>
                <a href="#">
                  <span className="fa fa-google-plus"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
{/* Header start */}
        <div style={{padding:"0px 0px"}} className="header-upper" ref={headerRef}>
          <div className="container-fluid clearfix">
            <div className="logo float-left mobile-view-show">
            <a href="index.html" className="img-responsive">
              <img src={require("../../images/logo.png")} alt="" title="" />
            </a>
          </div>
            <div className="menu-area float-right clearfix">
              <nav className="main-menu navbar-expand-lg float-left">
                <div className="navbar-header">
                  <button
                    onClick={handleToggle}
                    type="button"
                    className="navbar-toggle"
                    data-toggle="collapse"
                    data-target=".navbar-collapse"
                  >
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                    <span className="icon-bar"></span>
                  </button>
                </div>
                {isToggle ? (
                  <div 
                    style={{ display: "block" }}
                    className="navbar-collapse collapse clearfix mobile-view-show"
                  >
                    <ul style={{paddingLeft:"0px"}} className="navigation clearfix">
                     
                      <li className="current">
                        <a href="">Home</a>
                      </li>
                      <li>
                        <a href="about.html">About</a>
                      </li>
                      <li className="dropdown">
                        <a href="">Services</a>
                        <ul>
                          <li>
                            <a href="services.html">Our Services</a>
                          </li>
                          <li>
                            <a href="services-details.html">Services Details</a>
                          </li>
                        </ul>
                      </li>
                     
                     
                      <li className="dropdown">
                        <a href="#">Blog</a>
                        <ul>
                          <li>
                            <a href="blog.html">Blog</a>
                          </li>
                          <li>
                            <a href="blog-details.html">Blog Details</a>
                          </li>
                        </ul>
                      </li>
                      <li>
                        <a href="contact.html">Contact Us</a>
                      </li>
                    </ul>
                  </div>
                ) : null}
                {/* first Header */}
              <div
      style={{ display: "block" }}
      className="navbar-collapse collapse clearfix mobile-view-hide"
    >
     <div
      style={{ display: "block" }}
      className="header-upper"
      ref={headerRef}
    >
      <div className="container-fluid clearfix">
        <nav className="main-menu navbar-expand-lg float-left">
          <ul className="navigation clearfix">
            {/* Logo */}
            <li>
              <a href="#" style={{ padding: "4px 0 0 0" }}>
                <img
                  src={require("../../images/logo.png")}
                  alt="Logo"
                  title="Logo Title"
                />
              </a>
            </li>

            {/* Home */}
            <li className="current">
              <a href="#">Home</a>
            </li>

            {/* About */}
            <li>
              <a href="about.html">About</a>
            </li>

            {/* Services Dropdown */}
            <li
              className="dropdown"
              style={{ position: "relative", cursor: "pointer" }}
              onMouseEnter={() => setServicesDropdownVisible(true)}
              onMouseLeave={() => setServicesDropdownVisible(false)}
              // onClick={() => toggleDropdown("services")}
            >
              <a href="#">Services</a>
              <ul
                style={{
                  display: servicesDropdownVisible ? "block" : "none",
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  listStyle: "none",
                  padding: "0",
                  margin: "0",
                  border: "1px solid #ccc",
                  zIndex: 1000,
                }}
              >
                <li style={{ padding: "10px 15px" }}>
                  <a
                    href="services.html"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    Our Services
                  </a>
                </li>
                <li style={{ padding: "10px 15px" }}>
                  <a
                    href="services-details.html"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    Services Details
                  </a>
                </li>
              </ul>
            </li>

            {/* Blog Dropdown */}
           

            <li
              className="dropdown"
              style={{ position: "relative", cursor: "pointer" }}
              onMouseEnter={() => setBlogDropdownVisible(true)}
              onMouseLeave={() => setBlogDropdownVisible(false)}
              // onClick={() => toggleDropdown("blog")}
            >
              <a href="#">Blog</a>
              <ul
                style={{
                  display: blogDropdownVisible ? "block" : "none",
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  listStyle: "none",
                  padding: "0",
                  margin: "0",
                  border: "1px solid #ccc",
                  zIndex: 1000,
                }}
              >
                <li style={{ padding: "10px 15px" }}>
                  <a
                    href="blog.html"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    Blog
                  </a>
                </li>
                <li style={{ padding: "10px 15px" }}>
                  <a
                    href="blog-details.html"
                    style={{ textDecoration: "none", color: "#000" }}
                  >
                    Blog Details
                  </a>
                </li>
              </ul>
            </li>

            {/* Contact */}
            <li>
              <a href="contact.html">Contact Us</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    </div>
                {/* first Header End*/}
      </nav>
              <div className="cont-info float-right clearfix">
                <div className="curt-button float-left">
                  <a href="#">
                    <FontAwesomeIcon
                      className="shoppingCartIcon"
                      icon={faShoppingBag}
                    />
                  </a>
                </div>
                <div className="contact-button float-right">
                  <a href="#" className="theme-btn btn-style-one">
                    <i className="flaticon-headphones"></i>+91-9999136186
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
{/* Header End */}
        <div className="sticky-header">
          <div className="container-fluid clearfix">
            <Link to="/">
              <div className="logo float-left">
                <a className="img-responsive">
                  <img src={require("../../images/logo.png")} alt="" title="" />
                </a>
              </div>
            </Link>
            <div className="right-col float-right">
              <nav className="main-menu navbar-expand-lg">
                <div className="navbar-collapse collapse clearfix">
                  <ul className="navigation clearfix">
                    <li className="">
                      <a href="index.html">Home</a>
                    </li>
                    <li>
                      <a href="about.html">About</a>
                    </li>
                    <li className="dropdown">
                      <a href="#">Services</a>
                      <ul>
                        <li>
                          <a href="services.html">Our Services</a>
                        </li>
                        <li>
                          <a href="services-details.html">Services Details</a>
                        </li>
                      </ul>
                    </li>
                    {/* <li className="dropdown">
                    <a href="#">Pages</a>
                    <ul>
                      <li>
                        <a href="gallery.html">Gallery</a>
                      </li>
                      <li>
                        <a href="faq.html">FAQ</a>
                      </li>
                      <li>
                        <a href="team.html">Our Team</a>
                      </li>
                      <li>
                        <a href="testimonial.html">testimonials</a>
                      </li>
                    </ul>
                  </li>
                  <li className="dropdown">
                    <a href="#">Shop</a>
                    <ul>
                      <li>
                        <a href="shop.html">Shop</a>
                      </li>
                      <li>
                        <a href="cart.html">Shopping Cart</a>
                      </li>
                      <li>
                        <a href="checkout.html">Checkout</a>
                      </li>
                      <li>
                        <a href="single-product.html">Single Produt</a>
                      </li>
                    </ul>
                  </li> */}
                    <li className="dropdown">
                      <a href="#">Blog</a>
                      <ul>
                        <li>
                          <a href="blog.html">Blog</a>
                        </li>
                        <li>
                          <a href="blog-details.html">Blog Details</a>
                        </li>
                      </ul>
                    </li>
                    <li>
                      <a href="contact.html">Contact Us</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
}

export default Header;
